/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react'
import '../../Style/Table4.css'
import MaterialTable from 'material-table'
import { Grid } from '@material-ui/core'
import { getServicesAccess } from '../../../../../services/Elegibilidad/get'
import { UpdateServicesAccess } from '../../../../../services/Elegibilidad/put'
import EditIcon from '@mui/icons-material/Edit'
import { useEligibility } from '../../../../../context/EligibilityContext'
import { useFormElegibilidad } from '../../../../../context/ElegibilidadContext'
import swal from 'sweetalert'

const Table395 = ({ idElegibilityForm, MiPymeType, men, women }) => {
  const [state, dispatch] = useEligibility()
  const { EligibilityForm } = useFormElegibilidad()
  const [tableDataServices, setTableDataServices] = useState([])

  const getDataTableServices = async () => {
    try {
      const response = await getServicesAccess(idElegibilityForm)
      if (response.Success) {
        setTableDataServices(response.Data)
      }
    } catch (error) {
      console.log(error)
    }
  }

  let womenValidation
  let menValidation
  let IsCheck = null

  if (MiPymeType === 'Persona Natural') {
    womenValidation = EligibilityForm.WomenEmployees
    menValidation = EligibilityForm.MenEmployees
    if (EligibilityForm.Gender === 'Femenino') womenValidation += 1
    if (EligibilityForm.Gender === 'Masculino') menValidation += 1
  } else {
    womenValidation = Number(
      EligibilityForm.WomenCount + EligibilityForm.WomenEmployees,
    )
    menValidation = Number(
      EligibilityForm.MenCount + EligibilityForm.MenEmployees,
    )
  }

  useEffect(() => {
    if (
      state.step === 3 &&
      idElegibilityForm !== undefined &&
      idElegibilityForm !== null &&
      tableDataServices.length === 0
    ) {
      getDataTableServices()
    }
  }, [state.step])

  const alertValidationFields = () => {
    swal({
      title:
        'Debe ingresar la cantidad de hombres y mujeres que tienen acceso al servicio',
      icon: 'warning',
      button: 'Entendido',
      className: 'swal-title',
    })
  }

  const handleActualizar = async (data) => {
    const body = {
      IdElegibilityAnswer: data.IdElegibilityAnswer,
      IdService: data.IdService,
      IsCheck: IsCheck,
      Men: data.Men !== null ? Number(data.Men) : null,
      Women: data.Women !== null ? Number(data.Women) : null,
    }

    const response = await UpdateServicesAccess(body)
    if (response.Success) {
      getDataTableServices()
      IsCheck = null
    }
  }

  const columns = [
    {
      title: 'Servicio',
      field: 'FieldDescription',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      editable: 'never',
    },
    {
      title: 'Seleccione si la MIPYME tiene acceso al servicio',
      field: 'IsCheck',
      sorting: false,
      filtering: false,
      // cellStyle: { background: '#009688' },
      // headerStyle: { color: '#fff' },
      type: 'boolean',
      align: 'center',
      editComponent: (props) => {
        if (IsCheck === null) {
          IsCheck = props.value
        }
        return (
          <Grid style={{ marginLeft: '32%' }}>
            <input
              type="checkbox"
              id="checkMen"
              defaultValue={props.value}
              defaultChecked={props.value}
              style={{ width: '20px', height: '20px' }}
              onChange={(e) => {
                if (e.target.checked === true) {
                  IsCheck = true
                } else {
                  IsCheck = false
                }
              }}
            />
          </Grid>
        )
      },
    },
    {
      title: 'Hombres',
      field: 'Men',
      sorting: false,
      filtering: false,
      type: 'numeric',
      validate: (rowData) =>
        rowData.Men > menValidation
          ? 'No puede ser mayor al total de hombres'
          : '',
    },
    {
      title: 'Mujeres',
      field: 'Women',
      sorting: false,
      filtering: false,
      type: 'numeric',
      align: 'center',
      validate: (rowData) =>
        rowData.Women > womenValidation
          ? 'No puede ser mayor al total de mujeres'
          : '',
    },
  ]
  return (
    <div className="App">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <MaterialTable
            columns={columns}
            data={tableDataServices}
            editable={{
              onRowUpdate: (newData, oldData, rowData) =>
                new Promise((resolve, reject) => {
                  if (IsCheck === true)
                    if (
                      newData.Men !== null &&
                      newData.Women !== null &&
                      (newData.Men !== 0 || newData.Women !== 0)
                    ) {
                      handleActualizar(newData)
                    } else {
                      alertValidationFields()
                    }
                  resolve()
                  setTimeout(() => {}, 1000)
                }),
            }}
            onSelectionChange={(selectedRows) => console.log(selectedRows)}
            options={{
              sorting: true,
              search: true,
              searchFieldAlignment: 'right',
              searchAutoFocus: true,
              searchFieldVariant: 'standard',
              filtering: true,
              paging: false,
              pageSizeOptions: [2, 5, 10, 20],
              pageSize: 5,
              paginationType: 'stepped',
              showFirstLastPageButtons: false,
              paginationPosition: 'bottom',

              exportFileName: 'TableData',
              addRowPosition: 'first',
              actionsColumnIndex: -1,
              showSelectAllCheckbox: false,
              showTextRowsSelected: false,
              selectionProps: (rowData) => ({
                disabled: rowData.age == null,
                // color:"primary"
              }),

              rowStyle: (data, index) =>
                index % 2 === 0 ? { background: '#f5f5f5' } : null,
              headerStyle: { background: '#004BCE', color: '#fff' },
            }}
            localization={{
              body: {
                editRow: {
                  deleteText: '¿Está seguro de eliminar el registro?',
                },
                emptyDataSourceMessage: 'No hay registros a desplegar',
              },
              header: {
                actions: 'Acciones',
              },
              toolbar: {
                searchPlaceholder: 'Buscar',
              },
            }}
            title=" "
            icons={{
              Edit: () => <EditIcon style={{ color: '#0d53ad' }} />,
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default React.memo(Table395)
